import useTrackNewFeature from "../../actions/user/useTrackNewFeature.ts";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import useSupportsRecommendations from "./useSupportsRecommendations.ts";

export default function useIsRecommendationsNew() {
  const supportsRecommendations = useSupportsRecommendations();

  return useTrackNewFeature({
    preferenceKey: UserPreferenceKey.RecommendationsLive,
    numDays: 30,
    isFeatureLive: supportsRecommendations,
  });
}
